import React, { Suspense } from 'react'
// import router from './router/router'
// import { useRoutes } from 'react-router'
import Home from './Home/Home'

export default function App() {

  return (
    <div>
      <Home></Home>
    </div>
  )
}

